import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

function SaveEnrollementPopup({ isClose, isOpen }) {
  const saveResponse = useSelector((s) => s?.legalEnrollment?.saveResponse);

  const gotosuyool = () => {
    if (saveResponse.Title === "Success") {
      window.location.href = "https://www.suyool.com";
    } else {
      isClose(false);
    }
  };

  return (
    <Modal centered show={isOpen} onHide={isClose} className="pdf-popup">
      <Modal.Body>
        <div>{saveResponse?.Title}</div>
        <div>
          {saveResponse?.Message}
          <div onClick={gotosuyool}>Ok</div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SaveEnrollementPopup;
